import { render, staticRenderFns } from "./CommonUseForFling.vue?vue&type=template&id=38755cf8&scoped=true&"
import script from "./CommonUseForFling.vue?vue&type=script&lang=js&"
export * from "./CommonUseForFling.vue?vue&type=script&lang=js&"
import style0 from "./CommonUseForFling.vue?vue&type=style&index=0&id=38755cf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38755cf8",
  null
  
)

export default component.exports